export default {
  messmittel: '182A6FA2E95',
  pruefmittel: '182A6FA2E9C',
};
